import calculateDistanceFromHorizontalFieldOfView from 'helpers/calculations/calculateDistanceFromHorizontalFieldOfView'
import calculatePpf from 'helpers/calculations/calculatePpf'
import calculateHorizontalFieldOfViewFromVerticalFieldOfView from 'helpers/calculations/calculateHorizontalFieldOfViewFromVerticalFieldOfView'
import calculateDistanceFromDistanceToTarget from 'helpers/calculations/calculateDistanceFromDistanceToTarget'
import v from 'helpers/validator/validator'

/**
 * Calculates the vertical field of view and dependents distance to target, ppf, horizontal
 * field of view, and distance.  Vertical field of view passed in also gets validated.
 * @param {Object} camera - The current camera being updated.
 * @param {String} verticalFieldOfView - The vertical field of view to apply and calculate with.
 * @return {Object} The camera passsed in with updated attributes.
*/

export default function updateVerticalFieldOfView(camera, verticalFieldOfView) {
  const { verticalAngleOfView, verticalResolution, aspectRatio, tilt } = camera

  const validatedVerticalFieldOfView = v.validateGreaterThanZero(verticalFieldOfView).internal
  const horizontalFieldOfView = calculateHorizontalFieldOfViewFromVerticalFieldOfView({ verticalFieldOfView: validatedVerticalFieldOfView, aspectRatio })
  // same calculation, just with the appropriate angle
  const distanceToTarget = calculateDistanceFromHorizontalFieldOfView({ horizontalFieldOfView: validatedVerticalFieldOfView, angleOfView: verticalAngleOfView })

  return Object.assign({}, camera, {
    verticalFieldOfView: validatedVerticalFieldOfView,
    horizontalFieldOfView,
    distanceToTarget,
    ppf: calculatePpf({ horizontalResolution: verticalResolution, horizontalFieldOfView: validatedVerticalFieldOfView }), // since we're in corridor mode
    distance: calculateDistanceFromDistanceToTarget({ distanceToTarget, tilt })
  })
}



// WEBPACK FOOTER //
// ./src/reducers/updateVerticalFieldOfView.js